{
  "aboutFarmUserPermissions": "À propos des autorisations des utilisateurs de la ferme",
  "canControlDevicesRemotely": {
    "displayName": "Utiliser les télécommandes",
    "extendedDescription": "Envoyez des commandes et des demandes directes aux appareils de votre ferme, ce qui vous permet de contrôler leurs commutateurs et d'effectuer d'autres actions."
  },
  "canManageCustomTriggers": {
    "displayName": "Créer des connexions d'appareils",
    "extendedDescription": "Créez, modifiez et supprimez des connexions entre des appareils, y compris des actions qui peuvent être déclenchées si un appareil passe d'un état à un autre."
  },
  "canManageDeviceConfiguration": {
    "displayName": "Modifier les configurations",
    "extendedDescription": "Créez, modifiez et supprimez les étalonnages des capteurs de l'appareil et les personnalisations de l'appareil (le nom d'affichage de l'appareil dans l'application, par exemple)."
  },
  "canManageDeviceNotifications": {
    "displayName": "Créer des notifications personnalisées",
    "extendedDescription": "Configurez des alertes pour avertir votre équipe lorsque l'état d'un appareil change."
  },
  "canManageDevicePermissions": {
    "displayName": "Partager des appareils",
    "extendedDescription": "Gérez l'accès et le contrôle d'un appareil spécifique pour d'autres utilisateurs à l'intérieur ou à l'extérieur de votre ferme."
  },
  "canManageFarmAccount": {
    "displayName": "Modifier les détails du compte de la ferme",
    "extendedDescription": "Gérer les détails liés à l'administration de l'entreprise (par exemple, modifier l'adresse indiquée de la ferme)."
  },
  "canManageFields": {
    "displayName": "Gérer les champs",
    "extendedDescription": "Créez, modifiez et supprimez les champs de votre ferme et les enregistrements d'irrigation associés."
  },
  "canManageJoinCodes": {
    "displayName": "Gérer les codes d'adhésion à la ferme",
    "extendedDescription": "Accordez aux utilisateurs l’accès et les autorisations sur votre compte de ferme."
  },
  "canManageSchedules": {
    "displayName": "Gérer les horaires des appareils",
    "extendedDescription": "Créez et modifiez des actions ponctuelles et récurrentes pour les appareils."
  },
  "canManageUserPermission": {
    "displayName": "Modifier les autres autorisations d'utilisateur",
    "extendedDescription": "Accordez ou révoquez des autorisations au niveau de la batterie à d’autres utilisateurs de votre batterie."
  },
  "devicePermissionsDescription": "Autoriser l'utilisateur à effectuer des actions sur les appareils de la ferme.",
  "devicePermissionsTitle": "Autorisations de l'appareil",
  "farmPermissionsDescription": "Permettre à l'utilisateur de gérer les aspects du compte de la ferme.",
  "farmPermissionsTitle": "Autorisations de ferme",
  "farmUserPermissionsAllowYouTo": "Les autorisations de ferme et d'appareil vous permettent d'effectuer certaines actions dans FarmHQ. Ces autorisations peuvent être accordées ou révoquées par un administrateur de ferme.",
  "farmUserPermissionsHelpSummary": "Les autorisations des utilisateurs de la ferme déterminent les actions qui peuvent être effectuées par un utilisateur donné. Cela permet au gestionnaire de la ferme de protéger ses appareils contre toute utilisation abusive par d'autres (intentionnellement ou non).\n\nCela peut également libérer le gestionnaire de la ferme et les autres employés de la ferme de la crainte d'effectuer accidentellement des actions qui pourraient avoir des conséquences imprévues.",
  "farmUserPermissionsTitle": "Autorisations des utilisateurs de la ferme",
  "permissionDenied": "Permission refusée",
  "thisPermission": "Cette autorisation :",
  "youDoNotHavePermission": "Vous n'avez pas l'autorisation d'effectuer cette action. Contactez un administrateur de votre compte pour y accéder.",
  "youDoNotHavePermissionToAccessThisResource": "Vous n'avez pas l'autorisation d'accéder à cette ressource. Contactez un administrateur de votre compte pour y accéder."
}
